import { Building2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  onAdd: () => void;
}

export default function EmptyState({ onAdd }: EmptyStateProps) {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mx-auto mb-4">
          <Building2 className="w-8 h-8 text-muted-foreground/40" />
        </div>
        <h2 className="text-lg font-medium text-foreground">No locations yet</h2>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
          Add a location to track permits, inspections, and financials — everything in one place per unit.
        </p>
        <Button className="mt-5 gap-1.5" onClick={onAdd}>
          <Plus className="w-4 h-4" /> Add Location
        </Button>
      </div>
    </div>
  );
}
